<template>
    <div
        class="bg-white px-8 transition-all duration-500 xl:px-0"
        :class="scrolled ? 'py-4 shadow-[0_8px_10px_rgba(0,0,0,0.05)]' : 'py-6 shadow-none'"
    >
        <div class="mx-auto max-w-7xl">
            <div class="flex items-center justify-between">
                <h1 class="text-2xl font-extrabold">
                    <InertiaLink href="/">
                        <img src="/images/logos/camaq.webp" alt="CAMAQ" class="h-16 w-40 object-contain" />
                    </InertiaLink>
                </h1>

                <nav class="flex items-center space-x-8">
                    <InertiaLink
                        v-for="link in links"
                        :key="link.url"
                        :href="link.url"
                        class="nav-underline pb-1 font-medium text-camaq-900 hover:text-primary"
                    >
                        {{ link.name }}
                    </InertiaLink>

                    <a :href="otherLocaleHref" class="btn-primaire text-sm font-medium">
                        <span>{{ otherLocaleLabel }}</span>
                    </a>
                </nav>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { usePage } from '@inertiajs/inertia-vue3';
    import { trans } from 'laravel-vue-i18n';
    import { computed } from 'vue';

    defineProps({
        scrolled: {
            type: Boolean,
            default: false,
        },
    });

    const locale = computed(() => usePage().props.value.locale);

    const prefix = computed(() => locale.value === 'en' ? '/en' : '');

    const links = computed(() => [
        { name: trans('Job opportunities'), url: locale.value == 'fr' ? '/emplois' : `${prefix.value}/job-opportunities` },
        { name: 'Formations', url: `${prefix.value}/formations` },
        { name: trans('Internships'), url: locale.value == 'fr' ? '/stages' : `${prefix.value}/internships` },
        { name: trans('Events'), url: locale.value == 'fr' ? '/evenements' : `${prefix.value}/events` },
    ]);

    const otherLocaleLabel = computed(() => {
        return locale.value === 'fr' ? 'EN' : 'FR';
    });

    const otherLocaleHref = computed(() => {
        return usePage().props.value.otherLocaleUrl;
    });
</script>
